/* Shadeday — tiroir panier maison (sections/sd-cart-drawer.liquid).
   - s'ouvre après un ajout (événement 'sd:cart:added' émis par sd-cart.js) et au clic sur l'icône panier du header
     (Horizon est en cart_type « page » : <a class="… action__cart" href="/cart">)
   - se recharge via l'API Section Rendering (?sections=sd-cart-drawer)
   - quantités / suppression / relance « Upgrade to 3 → 5 bottles » (ajoute des bouteilles de la teinte de la 1re ligne)
   - assurance « Shipping Protection » : ajoutée d'office après un ajout si le réglage est actif ET si le pays l'autorise
     (jamais au Royaume-Uni ni dans l'UE/EEE) ET si le client ne l'a pas retirée ; un retrait est mémorisé pour la session
   - minuteur « Cart reserved for » : repart à chaque ouverture
   - prévient Horizon (bulle du header) par un CartLinesUpdateEvent, sans boucler sur ses propres événements */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const SD = (window.SD = window.SD || {});
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const SECTION = 'sd-cart-drawer';
const OPTOUT_KEY = 'sd_ins_optout'; // refus de l'assurance mémorisé pour la session (+ attribut de panier _ins_off)

let host = document.getElementById('sd-cart-drawer');
let lastFocus = null;
let busy = false;
let ownEvents = 0; // événements que nous émettons nous-mêmes (ignorés par notre écouteur)

const $ = (sel, el) => (el || host).querySelector(sel);

function isOpen() {
  return !!host && host.classList.contains('is-open');
}

async function refresh() {
  if (!host) return;
  const scroller = $('[data-sdd-scroll]');
  const keep = scroller ? scroller.scrollTop : 0;
  try {
    const res = await fetch(`${root}?sections=${SECTION}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await res.json();
    const html = data && data[SECTION];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-sdd-inner]');
    const inner = $('[data-sdd-inner]');
    if (fresh && inner) inner.innerHTML = fresh.innerHTML;
    const freshHost = doc.querySelector('[data-sdd]');
    if (freshHost) {
      host.dataset.insAuto = freshHost.dataset.insAuto || '0';
      host.dataset.insVariant = freshHost.dataset.insVariant || '';
    }
    const sc = $('[data-sdd-scroll]');
    if (sc) sc.scrollTop = keep;
    tickTimer();
  } catch (e) {
    /* le tiroir reste affiché avec l'ancien contenu */
  }
}

function focusables() {
  return [...host.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')]
    .filter((el) => el.offsetParent !== null);
}

function onKey(e) {
  if (!isOpen()) return;
  if (e.key === 'Escape') { e.preventDefault(); close(); return; }
  if (e.key !== 'Tab') return;
  const f = focusables();
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}

function open() {
  if (!host) return;
  if (!isOpen()) lastFocus = document.activeElement;
  host.hidden = false;
  document.documentElement.setAttribute('scroll-lock', '');
  requestAnimationFrame(() => requestAnimationFrame(() => host.classList.add('is-open')));
  setTimeout(() => { const panel = $('.sdd__panel'); if (panel) panel.focus({ preventScroll: true }); }, 60);
  document.addEventListener('keydown', onKey);
}

function close() {
  if (!host || !isOpen()) return;
  host.classList.remove('is-open');
  document.documentElement.removeAttribute('scroll-lock');
  document.removeEventListener('keydown', onKey);
  setTimeout(() => { if (!isOpen()) host.hidden = true; }, 330);
  if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
}

function notifyHorizon(action, cart, lines) {
  try {
    ownEvents++;
    const deferred = CartLinesUpdateEvent.createPromise();
    document.body.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines: lines || [], promise: deferred.promise }));
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'sd-drawer', didError: false, items: cart.items } });
  } catch (e) {
    /* pas bloquant */
  } finally {
    setTimeout(() => { ownEvents = Math.max(0, ownEvents - 1); }, 50);
  }
}

function showMsg(text) {
  const m = $('[data-sdd-msg]');
  if (!m) return;
  m.textContent = text || '';
  m.hidden = !text;
}

async function post(url, body) {
  const res = await fetch(`${root}${url}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok || data.status) {
    throw new Error(data.description || data.message || 'Cart error');
  }
  return data;
}

async function getCart() {
  return (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
}

async function changeLine(key, quantity, lineEl) {
  if (busy) return;
  busy = true;
  if (lineEl) lineEl.classList.add('is-busy');
  showMsg('');
  try {
    const cart = await post('cart/change.js', { id: key, quantity });
    notifyHorizon('update', cart, []);
    await syncInsurance(false);
    await refresh();
  } catch (e) {
    showMsg(e.message);
    if (lineEl) lineEl.classList.remove('is-busy');
  } finally {
    busy = false;
  }
}

function setLoading(btn, on) {
  if (!btn) return;
  const label = btn.querySelector('[data-sdd-label]');
  if (label && btn.dataset.loadingLabel) {
    if (on) { btn.dataset.idleLabel = label.textContent; label.textContent = btn.dataset.loadingLabel; }
    else if (btn.dataset.idleLabel) label.textContent = btn.dataset.idleLabel;
  }
  btn.classList.toggle('is-loading', on);
  btn.disabled = on;
  if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  const card = btn.closest('.sdd__upgrade');
  if (card) card.classList.toggle('is-loading', on);
}

/* Relance : ajoute (3 − qté) ou (5 − qté) bouteilles de la teinte de la 1re ligne (même variante = même ligne). */
async function upgrade(btn) {
  if (busy) return;
  busy = true;
  setLoading(btn, true);
  showMsg('');
  try {
    const id = Number(btn.dataset.variant);
    const quantity = Math.max(1, Number(btn.dataset.add) || 1);
    await post('cart/add.js', { items: [{ id, quantity }] });
    const cart = await getCart();
    notifyHorizon('add', cart, [{ merchandiseId: String(id), quantity }]);
    await refresh();
  } catch (e) {
    showMsg(e.message);
    setLoading(btn, false);
  } finally {
    busy = false;
  }
}

/* ---- Assurance livraison ---------------------------------------------------------------------- */
function optedOut(cart) {
  let session = false;
  try { session = sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { /* stockage indisponible */ }
  return session || ((cart && cart.attributes) || {})._ins_off === '1';
}

function rememberOptOut(on) {
  try {
    if (on) sessionStorage.setItem(OPTOUT_KEY, '1'); else sessionStorage.removeItem(OPTOUT_KEY);
  } catch (e) { /* stockage indisponible */ }
}

/* Pré-cochage autorisé ? Réglage actif (calculé côté serveur avec le pays) ET pays du visiteur hors Royaume-Uni / UE / EEE. */
function precheckAllowed() {
  if (!host || host.dataset.insAuto !== '1') return false;
  const country = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
  const optin = String(host.dataset.insOptin || '').split(',');
  return !(country && optin.includes(country));
}

async function toggleInsurance(btn) {
  if (busy) return;
  busy = true;
  btn.classList.add('is-busy');
  showMsg('');
  const on = btn.getAttribute('aria-checked') !== 'true';
  try {
    if (on) {
      await post('cart/add.js', { items: [{ id: Number(btn.dataset.variant), quantity: 1 }] });
      await post('cart/update.js', { attributes: { _ins_off: '' } });
      rememberOptOut(false);
    } else {
      const cart0 = await getCart();
      const updates = {};
      cart0.items.filter((i) => i.handle === host.dataset.insHandle).forEach((i) => { updates[i.key] = 0; });
      await post('cart/update.js', { updates, attributes: { _ins_off: '1' } });
      rememberOptOut(true);
    }
    const cart = await getCart();
    notifyHorizon('update', cart, []);
    await refresh();
  } catch (e) {
    showMsg(e.message);
    btn.classList.remove('is-busy');
  } finally {
    busy = false;
  }
}

/* Après un ajout : assurance ajoutée d'office si autorisé et pas refusée ; retirée si le panier ne contient plus qu'elle. */
async function syncInsurance(afterAdd) {
  if (!host) return;
  const handle = host.dataset.insHandle;
  if (!handle) return;
  try {
    const cart = await getCart();
    const ins = cart.items.filter((i) => i.handle === handle);
    const others = cart.items.filter((i) => i.handle !== handle);
    if (ins.length && !others.length) {
      const updates = {};
      ins.forEach((i) => { updates[i.key] = 0; });
      await post('cart/update.js', { updates });
      notifyHorizon('update', await getCart(), []);
      return;
    }
    if (afterAdd && precheckAllowed() && !ins.length && others.length && !optedOut(cart)) {
      /* id porté par la racine du tiroir (présent même si le tiroir a été rendu panier vide) */
      const btn = host.querySelector('[data-sdd-ins]');
      const id = Number(host.dataset.insVariant) || Number(btn && btn.dataset.variant) || 0;
      if (id) {
        await post('cart/add.js', { items: [{ id, quantity: 1 }] });
        notifyHorizon('add', await getCart(), [{ merchandiseId: String(id), quantity: 1 }]);
      }
    }
  } catch (e) {
    /* pas bloquant */
  }
}

/* ---- Minuteur « Cart reserved for » : repart à chaque ouverture, masqué une fois écoulé ---------- */
let timerUntil = 0;
function tickTimer() {
  if (!host || !timerUntil) return;
  const el = host.querySelector('[data-sdd-timer]');
  const row = host.querySelector('[data-sdd-timer-row]');
  if (!el || !row) return;
  const left = Math.max(0, timerUntil - Date.now());
  if (left <= 0) { row.hidden = true; return; }
  const m = Math.floor(left / 60000), sec = Math.floor((left % 60000) / 1000);
  el.textContent = String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
  row.hidden = false;
}
function startTimer() {
  const el = host && host.querySelector('[data-sdd-timer]');
  timerUntil = el ? Date.now() + (Number(el.dataset.minutes) || 5) * 60 * 1000 : 0;
  tickTimer();
}
setInterval(() => { if (isOpen()) tickTimer(); }, 1000);
function openWithTimer() { open(); startTimer(); }

function bind() {
  host = document.getElementById('sd-cart-drawer');
  if (!host || host.dataset.sddBound) return;
  host.dataset.sddBound = '1';

  host.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-sdd-close]')) { e.preventDefault(); close(); return; }
    const line = t.closest('[data-sdd-line]');
    if (t.closest('[data-sdd-plus]') && line) { changeLine(line.dataset.key, Number(line.dataset.qty) + 1, line); return; }
    if (t.closest('[data-sdd-minus]') && line) { changeLine(line.dataset.key, Math.max(0, Number(line.dataset.qty) - 1), line); return; }
    if (t.closest('[data-sdd-remove]') && line) { changeLine(line.dataset.key, 0, line); return; }
    const up = t.closest('[data-sdd-upgrade]');
    if (up) { upgrade(up); return; }
    const ins = t.closest('[data-sdd-ins]');
    if (ins) toggleInsurance(ins);
  });

  // Icône panier du header (Horizon en mode « page »)
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.action__cart, #header-group a[href$="/cart"], header a[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    refresh();
    openWithTimer();
  });

  // Après un ajout depuis la fiche produit
  // 11/10 ordre Tarik « skip le cart » : on part direct au checkout (mettre SKIP_CART à false pour réafficher le tiroir).
  const SKIP_CART = false;
  document.addEventListener('sd:cart:added', async () => {
    await syncInsurance(true);
    if (SKIP_CART) { window.location.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}checkout`; return; }
    await refresh();
    openWithTimer();
  });

  // Autres changements du panier (Horizon, applis…) → on se remet à jour si ouvert
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (ownEvents > 0) return;
    const after = () => { if (isOpen()) refresh(); };
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then((r) => { if (!(r && r.detail && (r.detail.source === 'sd-drawer' || r.detail.source === 'sd'))) setTimeout(after, 200); }, () => {});
    } else {
      setTimeout(after, 200);
    }
  });
}

SD.cartDrawer = { open: openWithTimer, close, refresh };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
